
const receitaGridConfig = {
  idField: "idReceita",
  columns: [
    {
      header: "Descrição",
      field: "DESCRICAO",
      formatter: (descricao) => {
        if (descricao === "A") return "Agendamento";
        if (descricao === "V") return "Venda";
        return ""
      },
    },
    { header: "Número", field: "IDORIGEM" }, 
    { header: "Data", field: "DATA_LANCAMENTO" },  
    { header: "Valor", field: "valor" },
    { header: "Ativo", field: "ATIVO",
      formatter: (value) => (value ? "Sim" : "Não")
    }
  ]
};

export default receitaGridConfig;